import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconThumbsUp32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 13a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h1V13zm3-1.136V27h10.362a4 4 0 0 0 3.677-2.424l2.571-6c1.132-2.64-.805-5.576-3.676-5.576H19.5l.733-6.106c.234-1.95-2.19-3.034-3.488-1.56z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp32Filled);
